import * as Yup from 'yup';

const associateBuildTeacherSchema = Yup.object().shape({
  courseId: Yup.string().required('Course ID is required'),
  assignmentId: Yup.string().required('Assignment ID is required'),
  name: Yup.string().required('Name is required'),
  description: Yup.string().optional(),
});

export default associateBuildTeacherSchema;
